import { RouterRepository } from "./config.js";
import { Api } from "./api";

let commonApi = {
  deleteToken: { type: "POST", url: RouterRepository.auth.deleteToken },
  commonHospitalList: {
    type: "GET",
    url:
      RouterRepository.adminApi + "/hospitalCommons?projection=simple&size=200",
  },
  sendLog: {
    type: "POST",
    errorHandler: function () {
      /* do nothing */
    },
    url: RouterRepository.adminApi + "/appMenuLogs",
  },
};

let insuRestApi = {
  /**
   * 자동청구 구독 가능 확인
   */
  subscriptionsConfirm: {
    type: "POST",
    url: RouterRepository.openApi + "/v1/claims/subscriptions/confirm",
    test: { enabled: false, url: "" },
  },
  /**
   * 자동청구 신청내역
   */
  subscriptionsGet: {
    type: "GET",
    url: RouterRepository.openApi + "/v1/claims/subscriptions",
    test: { enabled: false, url: "" },
  },
  /**
   * 자동청구 구독
   */
  subscriptions: {
    type: "POST",
    url: RouterRepository.openApi + "/v1/claims/subscriptions",
    test: { enabled: false, url: "" },
  },
  /**
   * 자동청구 구독 철회
   */
  revokeSubscriptions: {
    type: "DELETE",
    url: RouterRepository.openApi + "/v1/claims/subscriptions",
    test: { enabled: false, url: "" },
  },
  /**
   * 자동청구 구독 병원 삭제
   */
  deleteSubscripHospital: {
    type: "DELETE",
    url: RouterRepository.openApi + "/v1/claims/subscriptions/hospitals",
    test: { enabled: false, url: "" },
  },
  /**
   * 자동청구 구독 철회 취소
   */
  subscriptionsPut: {
    type: "PUT",
    url: RouterRepository.openApi + "/v1/claims/subscriptions",
    test: { enabled: false, url: "" },
  },
  /**
   * 자동청구 병원 추가
   */
  subscriptionsHospitals: {
    type: "POST",
    url: RouterRepository.openApi + "/v1/claims/subscriptions/hospitals",
    test: { enabled: false, url: "" },
  },
  /**
   * 자동청구 병원 추가 V2
   */
  subscriptionsHospitalsV2: {
    type: "POST",
    url: RouterRepository.openApi + "/v2/claims/subscriptions/hospitals",
    test: { enabled: false, url: "" },
  },
  subscriptionsHospitalsV3: {
    type: "POST",
    url: RouterRepository.openApi + "/v2/claims/subscriptions/hospitals",
    test: { enabled: false, url: "" },
  },
  /**
   * 자동청구 병원 삭제
   */
  subscriptionsHospitalsDel: {
    type: "DELETE",
    url: RouterRepository.openApi + "/v1/claims/subscriptions/hospitals",
    test: { enabled: false, url: "" },
  },
  /**
   * 수신계좌등록 (청구의신 앱)
   */
  usersAccounts: {
    type: "POST",
    url: RouterRepository.openApi + "/v1/claims/users/accounts",
    test: { enabled: false, url: "" },
  },
  /**
   * 은행목록조회(미인증용)
   */
  getAutoBanks: {
    type: "GET",
    url: RouterRepository.openApi + "/v1/claims/banks",
    test: { enabled: false, url: "" },
  },
  /**
   * 보험사 목록조회(미인증용)
   */
  getAutoInsu: {
    type: "GET",
    url: RouterRepository.openApi + "/v1/claims/insurances",
    test: { enabled: false, url: "" },
  },
  /**
   * 계좌번호 유효성 체크(미인증용)
   */
  getAccountsConfirm: {
    type: "GET",
    url: RouterRepository.openApi + "/v1/claims/users/accounts",
    test: { enabled: false, url: "" },
  },
  /**
   * 병원 이름 얻기
   */
  getHospitalNm: {
    type: "GET",
    url: RouterRepository.insu + "/rest/findHospitalNm/${hospitalCd}",
    test: { enabled: false, url: "" },
  },
  /**
   * 우체국 보험사 리스트 조회
   */
  getPostOffice: {
    type: "GET",
    url: RouterRepository.openApi + "/v1/claims/insurances/fax-numbers",
    test: { enabled: false, url: "" },
  },
  /**
   * 직업코드 조회
   */
  getJobCode: {
    type: "GET",
    url: RouterRepository.openApi + "/v1/claims/job-codes",
    test: { enabled: false, url: "" },
  },
  /**
   * UI Control 조회
   */
  getUiContorl: {
    type: "GET",
    url: RouterRepository.openApi + "/v1/claims/ui-controls",
    test: { enabled: false, url: "" },
  },
  /**
   * 자동청구가능 병원정보
   */
  getHospitalOfInfo: {
    type: "GET",
    url: RouterRepository.openApi + "/v1/claims/hospitals/${hospitalCd}",
    test: { enabled: false, url: "" },
  },
  /**
   * 자동청구 가능 병원 목록 조회
   */
  getClaimPossibleHospitals: {
    type: "GET",
    url: RouterRepository.openApi + "/v1/claims/hospitals",
    test: { enabled: false, url: "" },
  },
  /**
   * 자동청구 가입 가능 내병원 조히
   */
  myHospitalClaimPossible: {
    type: "POST",
    url:
      RouterRepository.openApi + "/v1/claims/subscriptions/hospitals/confirm",
    test: { enabled: false, url: "" },
  },
  /**
   * 자동청구 신청 접수(멀티병원)
   */
  multiReceiptClaim: {
    type: "POST",
    url: RouterRepository.openApi + "/v2/claims/subscriptions",
    test: { enabled: false, url: "" },
  },

  /**
   * 이미지 OCR
   */
  postImgOCR: {
    type: "POST",
    url: RouterRepository.openApi + "/v1/ocr/document/id-card",
    test: { enabled: false, url: "" },
  },
  /**
   * 자동청구 진료예정 목록 저장
   */
  postAutoClaimTreatV2: {
    type: "POST",
    url: RouterRepository.coin + "/api/public/v2/claims/subscriptions/treats",
    test: { enabled: false, url: "" },
  },
  /**
   * 자동청구 신분증 및 진료 건수 조회
   */
  getAutoClaimCheck: {
    type: "GET",
    url: RouterRepository.coin + "/api/public/v1/claims/subscriptions/idCards",
    test: { enabled: false, url: "" },
  },
  /**
   * 자동청구 진료예정 목록 저장
   */
  postAutoClaimTreat: {
    type: "POST",
    url: RouterRepository.coin + "/api/public/v1/claims/subscriptions/treats",
    test: { enabled: false, url: "" },
  },
  /**
   * 자동청구 진료예정 목록
   */
  getAutoClaimTreat: {
    type: "GET",
    url: RouterRepository.coin + "/api/public/v1/claims/subscriptions/treats",
    test: { enabled: false, url: "" },
  },
  /**
   * 자동청구 신분증 저장
   */
  postAutoClaimIdCard: {
    type: "POST",
    url: RouterRepository.coin + "/api/public/v1/claims/subscriptions/idCards",
    test: { enabled: false, url: "" },
  },
  /**
   * 공통코드 조회
   */
  getCommonCode: {
    type: "GET",
    url: RouterRepository.openApi + "/v1/codes/clss",
    test: { enabled: false, url: "" },
  },
  /** 약관 목록 조회(미인증) */
  getTermsV2: {
    type: "GET",
    url: RouterRepository.local + "/auth/rest/terms/v2/TELECOM",
    test: { enabled: false, url: "" },
  },
  /** 약관 목록 조회 */
  getTerms: {
    type: "POST",
    url: RouterRepository.local + "/auth/rest/terms",
    test: { enabled: false, url: "" },
  },
  /**
   * 013.1 nice 인증요청
   */
  postUserAuth: {
    type: "POST",
    url: RouterRepository.local + "/auth/rest/nice/userAuth",
    test: { enabled: false, url: "" },
  },
  /**
   * 013.2 nice 인증번호확인
   */
  postSmsAuth: {
    type: "POST",
    url: RouterRepository.local + "/auth/rest/nice/smsAuth",
    test: { enabled: false, url: "" },
  },
  /** 자동청구 약관 목록 조회 */
  getTermsV3: {
    type: "GET",
    url: LemonhcRouter.local + "/auth/rest/terms/v3/LMHC_SUBS",
    test: { enabled: false, url: "" },
  },
};

let RestApi = class {
  constructor(apis) {
    this.apis = apis;
    var container = this;

    for (const [apiName, obj] of Object.entries(this.apis)) {
      obj.name = apiName;
      container.__defineGetter__(apiName, function () {
        if (this.apis[obj.name] instanceof Api) {
          return this.apis[obj.name];
        } else {
          return (this.apis[obj.name] = new Api(obj));
        }
      });
    }
    return this;
  }
};

insuRestApi = Object.assign({}, insuRestApi, commonApi);

export { insuRestApi, RestApi, RouterRepository };
